"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');








var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _format = require('./format');

 const POLL_MS = 2000; exports.POLL_MS = POLL_MS
// While nothing runs, the table still checks now and then for an archive or
// restore someone else started (review F-12). Once a minute: each check scans
// the task table, which has no index for it (review F-15).
 const IDLE_POLL_MS = 60000; exports.IDLE_POLL_MS = IDLE_POLL_MS











const pendingOf = (archives) => {
  const kinds = new Map()
  for (const a of archives) a.Pending.forEach(key => kinds.set(key, a.Restore ? 'restore' : 'archive'))
  return kinds
}

const plural = (n, one, many) => `${_format.formatCount.call(void 0, n)} ${n === 1 ? one : many}`

/* The notice an archive or restore ends with. Without its status (the read
 * failed) it doesn't know how it went, so it never says it succeeded
 * (review F-13). */
 const finishedNotice = (
  restore, total, status,
) => {
  const doing = restore ? 'Restoring' : 'Archiving'
  if (!status) {
    return { text: `${doing} ${plural(total, 'patient', 'patients')} ended, but we couldn't check how it went. The table shows each patient as they are now.`, isWarning: true }
  }
  const result = status.Result
  // Ended without finishing: it failed, or stopped saving its progress
  // (its process died) and no longer counts as running (Q-32).
  if (status.Failed || status.Stage !== 'finished') {
    return { text: `${doing} stopped before it finished. ${result ? `${_format.formatCount.call(void 0, result.Changed)} done.` : ''} Try again.`, isWarning: true }
  }
  const skipped = result && result.Skipped > 0
    ? `; ${plural(result.Skipped, 'patient was', 'patients were')} skipped (already ${restore ? 'active' : 'archived'} or no longer here)`
    : ''
  const done = `${restore ? 'Restored' : 'Archived'} ${plural(_nullishCoalesce(_optionalChain([result, 'optionalAccess', _ => _.Changed]), () => ( total)), 'patient', 'patients')}${skipped}.`
  // A patient whose change failed was left as they were (D-51).
  if (_optionalChain([result, 'optionalAccess', _2 => _2.Failed])) {
    return {
      text: `${done} ${plural(result.Failed, 'patient', 'patients')} couldn't be ${restore ? 'restored' : 'archived'} because of a temporary error and ${result.Failed === 1 ? 'was' : 'were'} left as before. ${restore ? 'Restore' : 'Archive'} again to finish.`,
      isWarning: true,
    }
  }
  return { text: done, isWarning: false }
}; exports.finishedNotice = finishedNotice













/* The org's running archives and restores, read from the server (D-61), so a
 * reload or another staff member sees them: read when the table opens, and
 * every 2 seconds while any run. Rows still waiting for one are pending; the
 * page reloads as each chunk finishes, never before the server has changed
 * those patients. */
 const useRunningArchives = ({ orgKey, rowKeys, onProgress, onFinished }) => {
  const [archives, setArchives] = _react.useState([])
  const [reads, setReads] = _react.useState.call(void 0, 0)
  const started = _react.useRef.call(void 0, new Map())
  const seen = _react.useRef.call(void 0, new Map())
  const latest = _react.useRef.call(void 0, { onProgress, onFinished })
  _react.useEffect.call(void 0, () => { latest.current = { onProgress, onFinished } }, [onProgress, onFinished])
  // When a task moves or ends, its rows keep their pending marks until the
  // page has reloaded, so a finished row never looks selectable before it
  // leaves (QA round 6).
  const [held, setHeld] = _react.useState(null)
  const shownRows = _react.useRef.call(void 0, rowKeys)
  _react.useEffect.call(void 0, () => {
    shownRows.current = rowKeys
    setHeld(h => h && h.rows !== rowKeys ? null : h)
  }, [rowKeys])

  const finish = _react.useCallback.call(void 0, (task) => {
    const mine = started.current.get(task.TaskKey)
    started.current.delete(task.TaskKey)
    const done = (status) => latest.current.onFinished(task, status, mine)
    // Any member reads how it ended (review F-13).
    _actions2.default.getPatientArchiveStatus({ OrgKey: orgKey, TaskKey: task.TaskKey })
      .then(done)
      .catch(() => done(null))
  }, [orgKey])

  // Reads are applied in the order they were sent, so an older one (a poll
  // sent before a start, or for rows no longer shown) never overwrites a
  // newer one.
  const sent = _react.useRef.call(void 0, 0)
  const applied = _react.useRef.call(void 0, 0)
  const startedAfter = _react.useRef.call(void 0, new Map())
  const read = _react.useCallback.call(void 0, (keys) => {
    const seq = ++sent.current
    return _actions2.default.getRunningPatientArchives({ OrgKey: orgKey, PatientKeys: keys })
      .then(({ Archives }) => {
        if (seq < applied.current) return
        applied.current = seq
        const now = new Map(Archives.map(a => [a.TaskKey, a]))
        // A task this page hasn't seen yet may be newer than the page's
        // select-all count, which then doesn't leave its patients out. That
        // includes the first read: it and the first page are separate
        // requests, so a task can start between them (review F-14).
        const hasNew = Archives.some(a => !seen.current.has(a.TaskKey))
        let hasMoved = false
        let hasEnded = false
        seen.current.forEach((before, key) => {
          const after = now.get(key)
          if (!after) {
            hasEnded = true
            finish(before)
          } else if (after.Done > before.Done) hasMoved = true
        })
        if (hasMoved || hasEnded) setHeld({ rows: shownRows.current, pending: pendingOf(seen.current.values()) })
        // One this page started that ended before it was ever listed: only a
        // read sent after the start can say so.
        started.current.forEach((task, key) => {
          if (!now.has(key) && !seen.current.has(key) && seq > (_nullishCoalesce(startedAfter.current.get(key), () => ( 0)))) {
            startedAfter.current.delete(key)
            finish({ TaskKey: key, Restore: task.restore, Total: task.count, Done: task.count, Pending: [] })
          }
        })
        seen.current = now
        setArchives(Archives)
        if (hasMoved || hasNew) latest.current.onProgress()
      })
      .catch(() => undefined)
  }, [orgKey, finish])

  // Every page the table loads is checked, even with the same rows (review
  // F-12).
  _react.useEffect.call(void 0, () => {
    read(rowKeys)
  }, [rowKeys, reads, read])

  // Before the table shows a page while a task runs, read which of its rows
  // are waiting, so a waiting row never shows without its mark (QA round 7).
  const prepare = _react.useCallback.call(void 0, 
    (keys) => seen.current.size > 0 || started.current.size > 0 ? read(keys) : Promise.resolve(),
    [read],
  )

  // Every 2 seconds while one runs; every 60 while none does, skipped while
  // the tab is hidden, so an archive someone else starts shows up (review
  // F-12).
  const isRunning = archives.length > 0
  _react.useEffect.call(void 0, () => {
    const timer = setInterval(() => {
      if (isRunning || document.visibilityState !== 'hidden') setReads(n => n + 1)
    }, isRunning ? exports.POLL_MS : exports.IDLE_POLL_MS)
    return () => clearInterval(timer)
  }, [isRunning])

  // This page started one: read the running tasks now.
  const track = _react.useCallback.call(void 0, (key, task) => {
    started.current.set(key, task)
    startedAfter.current.set(key, sent.current)
    setReads(n => n + 1)
  }, [])

  const pending = _react.useMemo.call(void 0, () => {
    const kinds = pendingOf(archives)
    _optionalChain([held, 'optionalAccess', _3 => _3.pending, 'access', _4 => _4.forEach, 'call', _5 => _5((kind, key) => { if (!kinds.has(key)) kinds.set(key, kind) })])
    return kinds
  }, [archives, held])

  return { archives, pending, track, prepare }
}; exports.useRunningArchives = useRunningArchives
